import React, { useState, useEffect, useContext, Fragment } from 'react';

import { ComponentContext } from '../../context/componentContext';
import { AuthContext } from '../../context/authContext';
import { FarmContext } from '../../context/farmContext';
import { ProductContext } from '../../context/productContext';

import UnexpectedError from '../../components/UnexpectedError';
import FarmSection from '../../components/Farms/FarmSection';
import AvailableProduct from '../../components/AvailableProduct';

//images
import Illustration from '../../images/farm-illustration.svg';
import { Box, Flex, Heading, Image } from '@chakra-ui/core';

const Farms = ({ history }) => {
  document.title = 'CrowdFarmer | Farms';

  const { menuOpen, reload, unexpectedError, setUnexpectedError, setLoading } = useContext(
    ComponentContext
  );
  const { session, setSession } = useContext(AuthContext);
  const { fetchFarms, fetchActivities } = useContext(FarmContext);
  const { getProducts } = useContext(ProductContext);

  const [activeFarms, setActiveFarms] = useState(null);
  const [inActiveFarms, setInActiveFarms] = useState(null);
  const [completedFarms, setCompletedFarms] = useState(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (session) {
      (async () => {
        setLoading(true);
        try {
          let farms = await fetchFarms({ group: true });
          if (mounted)
            if (farms.code === 200) {
              if (Object.keys(farms.data).length === 0) {
                let products = await getProducts({ available: true });
                if (products.code === 200) {
                  if (products.data.length > 0) {
                    setIsEmpty(false);
                    setProducts(products.data);
                  }
                } else setUnexpectedError('Unexpected Server Error!');
              } else {
                setIsEmpty(false);
                const { active, inactive, completed } = farms.data;
                setActiveFarms(active);
                setInActiveFarms(inactive);
                setCompletedFarms(completed);
              }
            } else setUnexpectedError('Unexpected Server Error!');
        } catch (error) {
          if (error && error.status === 401) setSession(false);
          else setUnexpectedError('Unexpected Network Error!');
        }
        setLoading(false);
      })();
    }
    return () => (mounted = false);
  }, [
    reload,
    fetchFarms,
    getProducts,
    isEmpty,
    session,
    setLoading,
    setSession,
    setUnexpectedError
  ]);

  return (
    <Fragment>
      {unexpectedError ? (
        <UnexpectedError unexpectedError={unexpectedError} />
      ) : (
        <Box pt={40}>
          <Fragment>
            <Flex wra="wrap" justify="space-between" px={{ base: 16, md: 20, lg: 48 }}>
              <Heading as="h2">Welcome to your Farm(s)</Heading>
            </Flex>
            <Image
              w="100%"
              objectFit="center"
              mt={{ base: 6, md: -6 }}
              src={Illustration}
              alt="Maize"
            />
          </Fragment>
          <>
            {isEmpty ? (
              <Box pt={40} className="farms-bg">
                <Flex mx="auto" w="50%" flexDir="column" align="center" justify="center">
                  <Heading as="h2">You have no farm yet.</Heading>
                </Flex>
              </Box>
            ) : (
              <>
                {products.length > 0 ? (
                  <AvailableProduct title="farm" products={products} />
                ) : (
                  <>
                    <FarmSection
                      title="On Going"
                      farms={inActiveFarms}
                      setSession={setSession}
                      menuOpen={menuOpen}
                      setUnexpectedError={setUnexpectedError}
                      fetchActivities={fetchActivities}
                    />
                    <FarmSection
                      title="Payable"
                      farms={activeFarms}
                      setSession={setSession}
                      menuOpen={menuOpen}
                      setUnexpectedError={setUnexpectedError}
                      fetchActivities={fetchActivities}
                    />
                    <FarmSection
                      title="Past"
                      farms={completedFarms}
                      setSession={setSession}
                      menuOpen={menuOpen}
                      setUnexpectedError={setUnexpectedError}
                      fetchActivities={fetchActivities}
                    />
                  </>
                )}
              </>
            )}
          </>
        </Box>
      )}
    </Fragment>
  );
};

export default Farms;
